<template>
  <div class="project" >

    <nav class="navbar is-mobile is-medium" style="background-color: #30008A;" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
          <img id="navbar-logo" src="../../assets/projects/junction/junction19.jpg" alt="Solid Logo">
      </div>
    </nav>

      <h1 class="title"> Junction (2019) in Oulu </h1>
      <p>During my participation in JUNCTION in Oulu, I undertook a unique project – the creation of a synchronization tester enhanced by LED lights. This novel device was developed to ascertain the synchronization between two connected players in various scenarios. The LED lights played a pivotal role in visually indicating the synchronization status. When the inputs from both players aligned perfectly, a vibrant green LED illuminated, signifying optimal synchronization. An illuminating orange LED conveyed that the inputs were close to synchronization, while a noticeable red LED signaled a substantial disparity between the inputs. This creative endeavor showcased my ability to merge technical innovation with visual feedback, resulting in an engaging and informative tool.</p>
        <br>
        <video src="../../assets/projects/junction/Junction2019AfterMovie.mp4" controls autoplay></video>
        <br> <br>
        <h2 class="">Simon Says with Motion Sensors</h2>
        <p>
          The concept behind the project was to create a captivating and interactive "Simon Says" app that brought a twist to the classic game.
        </p>
        <br>
        <p>
          In our version, three participants took on the roles of followers, while another participant became the leader. What set this game apart was the integration of cutting-edge technology that made the experience both immersive and challenging.
        </p>
        <br>
        <p>
          In this unique twist on "Simon Says," all players were equipped with four motion sensors. These sensors, known as Movesense sensors, were provided by Suunto. The Movesense sensors were a game-changer in this project, as they could accurately detect and measure movements in real-time, allowing us to track even the slightest motions with precision.
        </p>
        <br>
        <p>
          The Movesense sensors, designed with impeccable Finnish engineering, offered a wide range of motion tracking capabilities. These sensors could monitor everything from subtle wrist movements to dynamic jumps and twists. They were compact, lightweight, and comfortable to wear, making them ideal for our interactive game.
        </p>
        <br>
        <p>
          To ensure seamless communication and data exchange between the Movesense sensors and the game application, we set up an MQTT broker system. MQTT (Message Queuing Telemetry Transport) facilitated the efficient transfer of motion data from the sensors to our game platform in real-time. It allowed us to collect and analyze the participants' movements instantaneously, making the game responsive and engaging.
        </p>
        <br>
        <p>
          The "Simon Says" app, enhanced by Movesense sensors and the MQTT broker, brought a new level of excitement to the traditional game. Players had to mimic the leader's movements precisely to earn points. The sensors accurately detected every motion, creating a dynamic and immersive experience. The challenge was intense; if the followers failed to match the leader's movements, points were deducted, adding a competitive edge to the game.
        </p>
        <br>
        <p>
          Overall, this project exemplified the fusion of innovative technology and classic fun. It showcased how technology can elevate even the most traditional of games, making them more interactive, competitive, and engaging. The combination of Movesense sensors and the MQTT setup transformed a simple idea into an extraordinary experience, leaving players with unforgettable memories and a deeper appreciation for the potential of modern technology in entertainment.
        </p>        <br>
        


          <div class="photo-grid">
    <div class="columns is-multiline">
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/loading.jpg" alt="Image 1">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/setup1.jpg" alt="Image 2">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/setup2.jpg" alt="Image 3">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/setup3.jpg" alt="Image 4">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/setup4.jpg" alt="Image 5">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/createlobby1.jpg" alt="Image 6">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/createlobby2.jpg" alt="Image 7">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/explenation1.jpg" alt="Image 8">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/explenation2.jpg" alt="Image 9">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/explenation3.jpg" alt="Image 10">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/explenation4.jpg" alt="Image 11">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/searchingopponents.jpg" alt="Image 12">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/searchingopponents2.jpg" alt="Image 13">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/scoreboard1.jpg" alt="Image 14">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/scoreboard2.jpg" alt="Image 15">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/result1.jpg" alt="Image 16">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/junction/result2.jpg" alt="Image 17">
        </figure>
      </div>
    </div>
  </div>
  <br> <br> <br>
  <h2 class=""> Some extra photos of the event</h2>
   <p>
      Overall, I had an extraordinary experience at the Junction event in Oulu. It was a gathering of like-minded individuals with a shared passion for technology in its broadest sense. Junction provided a unique platform for tech enthusiasts, creators, and innovators from all walks of life to come together, collaborate, and create. The event was not just about coding and engineering; it was a celebration of the limitless possibilities that technology offers to our world.
    </p> <br>
    <p>
      Junction wasn't merely a hackathon; it was a creative playground. It felt like a melting pot of ideas and talents, where individuals from various backgrounds, cultures, and skill sets converged to push the boundaries of innovation. The atmosphere was electric, filled with the hum of excitement and the buzz of collaboration. It was a place where the future of technology was being imagined, designed, and brought to life.
    </p> <b></b>
    <p>
      During the event, I had the chance to meet an array of friendly and inspiring people. Conversations flowed effortlessly, and knowledge was exchanged freely. It was remarkable to witness the collective drive and enthusiasm to tackle real-world challenges using technology.
    </p> <br>
    <p>
      But Junction wasn't all about work; it also offered opportunities for relaxation and enjoyment. I had the pleasure of participating in karaoke sessions, where tech wizards turned into rockstars. We also took a break from the intense hacking and brainstorming by unwinding in a sauna and enjoying a rejuvenating steam bath right in the event's parking area.
    </p> <br>
    <p>
      Junction left a lasting impression on me. It wasn't just an event; it was a transformative experience. It reaffirmed my belief in the power of technology to shape a better future and connect people from diverse backgrounds through shared innovation. I left Junction with a sense of purpose, a network of talented individuals, and memories that will stay with me for a lifetime.
    </p>  <br>
  <div class="photo-grid">
    <div class="columns is-multiline is-mobile">
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/junction/j1.jpg" alt="Image 1">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/junction/j2.jpg" alt="Image 2">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/junction/j3.jpg" alt="Image 3">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/junction/j4.jpg" alt="Image 4">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/junction/ht1.jpg" alt="Image 5">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/junction/ht2.jpg" alt="Image 6">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/junction/ht3.jpg" alt="Image 7">
        </figure>
      </div>
      <div class="column is-half">
        <figure class="image">
          <img src="../../assets/projects/junction/ht4.jpg" alt="Image 8">
        </figure>
      </div>
    </div>
  </div>
  
  </div>
</template>

<style scoped>
  
@import 'project.css';

</style>